// TODO: use the assertNever from aven_shared
export const assertNever = (argument: never, errorMessage: string): never => {
    throw new Error(errorMessage)
}
